// removed by extract-text-webpack-plugin
module.exports = {"siteWidth":"350px","siteHeight":"175px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app/styles/app-styles.scss
// module id = 208
// module chunks = 0